<template>
	<div class="form">
		<h4 class="step-title">Do you have another vehicle to add?</h4>
		<div
			class="step-content d-flex flex-column align-items-center step-button-list wider"
		>
			<yes-no-button-list v-bind:onclick="complete"/>
		</div>
	</div>
</template>

<script>
import YesNoButtonList from "../shared/YesNoButtonList.vue";

export default {
	name: "AddAnotherVehicle",
	components: {
		YesNoButtonList,
	},
	props: {
		lead: Object,
	},
	methods: {
		complete: function (value) {
			this.$emit("complete", this.$options.name, value);
		},
	},
};
</script>
